import React, { useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import changeImage from '../../assets/changeImage.png';
import editProf from '../../assets/editProf.png';
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import profile from '../../assets/profile.png';
import MuiAlert from '@material-ui/lab/Alert';
import { format } from 'date-fns';
import api from '../api';
import ImageUploader from 'react-images-upload';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useLocation } from 'react-router';
import ErrorRequest from '../ErrorRequest';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EditJadwalPoli(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const location = useLocation()
    console.log(props);
    const [waktu, set_waktu] = React.useState(props.detail[1])
    const [speciality, setListSpeciality] = useState([])
    const [spesialis, setSpesialis] = useState(null)
    const [photo, setPhoto] = useState("")
    const [uploadVisible, setUploadVisible] = useState(false)
    const [visibleError, setVisibleError] = useState(false)
    const [messageError, setMessageError] = useState(null)
    const [pictures, setPicture] = useState([])
    const [image, setImage] = useState([profile])
    const [name, setName] = React.useState(null)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState("")
    const [timeStart, setTimeStart] = React.useState(new Date(`${props.detail[1]} ${props.detail[2].slice(0, 5)}`))
    const [timeEnd, setTimeEnd] = React.useState(new Date(`${props.detail[1]} ${props.detail[3].slice(0, 5)}`))
    console.log(timeStart);

    // React.useEffect(() => {
    //     getDataSpesialis()
    // }, [])

    const handleOnChange = (e) => {
        setName(e.target.value)
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];
    console.log(name);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return ;
        }
        setOpenAlert(false)
    }

    const doSubmit = (e) => {
        let formData = new FormData()
        const id = props.detail[5]
        let time = `${new Date(waktu).getFullYear()}-${new Date(waktu).getMonth() + 1}-${new Date(waktu).getDate()}`
        let time_start = `${format(timeStart, 'HH:mm')}`
        let time_end = `${format(timeEnd, 'HH:mm')}`
        console.log(time_start);
        formData.append('id', id)
        formData.append('time_start', time_start)
        formData.append('time_end', time_end)
        formData.append("schedule_date", time)
        console.log(...formData);
        api.create().editSchedulePoli(formData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    props.openAlert(true)
                    props.messageAlert(response.data.message)
                    props.statusAlert("Succes")
                    props.onClose()
                    props.refresh()
                } else {
                    setVisibleError(true)
                    setMessageError(response.data.data)
                }
            }
        })
    }
    console.log(waktu);
    console.log(timeStart);
    console.log(timeEnd);

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Jadwal Klinik</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-2x" style={{ width: '40%', margin: 'auto', marginLeft: 40 }}>
                    <div className="column-1" style={{  width: 310 }}>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="tanggalBerlaku"
                                    label="Tanggal Berlaku"
                                    format="dd/MM/yyyy"
                                    minDate={new Date()}
                                    value={waktu}
                                    onChange={(date) => {
                                        set_waktu(date)
                                        forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    style={{marginTop: 20 }}
                                    margin="normal"
                                    id="jamMulai"
                                    clearLabel
                                    ampm={false}
                                    label="Jam Mulai"
                                    defaultValue=" "
                                    value={timeStart}
                                    onChange={(date) => setTimeStart(date)}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>
                    <div className="column-2" style={{width: 310}}>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    margin="normal"
                                    style={{ marginTop: 15, marginRight: 30}}
                                    id="jamSelesai"
                                    clearLabel
                                    ampm={false}
                                    label="Jam Selesai"
                                    defaultValue=" "
                                    value={timeEnd}
                                    onChange={(date) => setTimeEnd(date)}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
            {
                visibleError ? 
                <ErrorRequest
                    close={() => setVisibleError(false)}
                    message={messageError}
                />
                : null
            }
        </div>
    )
}